export * from './ost-result-list.component';
export * from './ost-result.component';